/**
 * A typed latitude or longitude: decimal degrees within ±max. Places (P8-10) and fill sites
 * (P8-12) take a point as two fields until the map picker (P8-21).
 */
export const isCoordinate = (value: string, max: number) =>
  // number-ok: coordinates, not money
  /^-?\d{1,3}(\.\d+)?$/.test(value.trim()) && Math.abs(Number.parseFloat(value)) <= max;

// number-ok: coordinates, not money
export const toCoordinate = (value: string) => Number.parseFloat(value);
